<template>
	<div>
		<section class="page-title" v-if="this.$vuetify.breakpoint.lg">
			<div class="center imagemBanner">
				<p class="label-planos">Credenciamento online</p>
				<h1 class="the-title">Junte-se a família <span>Primavida</span></h1>
				<p>Realize o aceite abaixo e finalize seu credenciamento</p>
			</div>
		</section>
		<section class="pagina-titulo" v-if="this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm">
			<v-img
                height="200"
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"
                position="center top"
            >
                <div class="centro">
                    <p class="rotulo-planos"><b>Credenciamento online</b></p>
                    <h1 class="o-titulo">Junte-se a família <span>Primavida</span></h1>
                    <p style="color:#7593b4">Realize o aceite abaixo e finalize seu credenciamento</p>
                </div>
            </v-img>
		</section>
		<section class="page-content center" style="margin-top: -30px">
			<div class="plano-selecionado" style="background: #f1f1f1;color:#009b9b;"><span>{{status}}</span></div>
			<v-stepper v-model="step" style="border-radius: 10px;">
				<v-stepper-header>
					<v-stepper-step :complete="step > 1" step="1">Dados</v-stepper-step>
					<v-divider v-if="filial.status != 'AGUARDANDO CONFIRMAÇÃO'"></v-divider>
					<v-stepper-step :complete="step > 2" step="2" v-if="filial.status == 'AGUARDANDO CONFIRMAÇÃO'">Confirmação</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<!-- PASSO 1 -->
					<v-stepper-content step="1">
						<v-card class="mb-4" color="grey lighten-3" flat>
							<v-container grid-list-md>
								<v-card-text v-if="carregaDados" style="text-align: center">
									<template>
										<v-progress-linear color="#009B99" :indeterminate="true"></v-progress-linear>
										<p style="color: #666">Carregando dados...</p>
									</template>
								</v-card-text>
								<v-card class="elevation-5" flat v-if="!carregaDados">
									<v-card-title class="headline mb-0">Informações da clínica</v-card-title>
									<v-divider />
									<v-card-text>
										<v-layout row wrap>
											<v-flex xs12 sm12 lg6>
												<v-text-field box label="Nome da clínica" readonly v-model="filial.nm_filial" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="CNPJ" readonly v-model="filial.nr_cgc" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="CRO" readonly v-model="filial.cro" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="CNES" readonly v-model="filial.cnes" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg6>
												<v-text-field box label="Responsável Técnico" readonly v-model="contatos[0].NmContato" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="Telefone" readonly v-model="contatos[0].Telefone" mask="(##) #####-####" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg12>
												<v-textarea box label="Especialidades" readonly v-model="especialidades" color="#009B99" auto-grow></v-textarea>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
								<br>
								<v-card class="elevation-5" flat v-if="!carregaDados">
									<v-card-title class="headline mb-0">Endereço</v-card-title>
									<v-divider />
									<v-card-text>
										<v-layout row wrap>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="CEP" readonly v-model="filial.logCep" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg7>
												<v-text-field box label="Endereço" readonly v-model="logradouro" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg2>
												<v-text-field box label="Nº" readonly v-model="filial.endNumero" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg4>
												<v-text-field box label="Complemento" readonly v-model="filial.endComplemento" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg2>
												<v-text-field box label="UF" readonly v-model="estado" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="Município" readonly v-model="cidade" color="#009B99"></v-text-field>
											</v-flex>
											<v-flex xs12 sm12 lg3>
												<v-text-field box label="Bairro" readonly v-model="bairro" color="#009B99"></v-text-field>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
								<br>
								<v-card class="elevation-5" flat v-if="!carregaDados">
									<v-card-title class="headline mb-0">Corpo Clínico</v-card-title>
									<v-divider />
									<v-card-text v-if="carregaDados" style="text-align: center">
										<template>
											<v-progress-linear color="#009B99" :indeterminate="true"></v-progress-linear>
											<p style="color: #666">Carregando dados...</p>
										</template>
									</v-card-text>
									<v-card-text v-else>
										<div v-for="funcionario in funcionarios" :key="funcionario.id">
											<v-layout row wrap>
												<v-flex xs12 sm12 lg6>
													<v-text-field box label="Nome Completo" readonly color="#009B99" v-model="funcionario.nomeEmpregado"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg3>
													<v-text-field box label="RG" readonly color="#009B99" v-model="funcionario.nr_identidade"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg3>
													<v-text-field box label="Órgão Emissor" readonly color="#009B99" v-model="funcionario.nm_orgaoexp"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg4>
													<v-text-field box label="CPF" readonly color="#009B99" v-model="funcionario.nr_cpf"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg4>
													<v-text-field box label="Data de Nascimento" readonly color="#009B99" :value="formatDateBrz(funcionario.dt_nascimento)"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg4>
													<v-text-field box label="CRO" readonly color="#009B99" v-model="funcionario.cro"></v-text-field>
												</v-flex>
												<v-flex xs12 sm12 lg12>
													<v-textarea box label="Especialidades" readonly color="#009B99" :value="funcionario.especialidades.toString().replaceAll(',', ', ')" auto-grow></v-textarea>
												</v-flex>
											</v-layout>
											<v-divider v-if="funcionarios.length > 1"></v-divider>
											<br v-if="funcionarios.length > 1">
										</div>
									</v-card-text>
								</v-card>
								<br>
								<v-card class="elevation-5" flat v-if="!carregaDados && filial.status == 'AGUARDANDO CONFIRMAÇÃO'">
									<v-card-text>
										<v-checkbox v-model="confirmaCadastro" color="#009B99">
											<span slot="label">Confirmo que as informações cadastradas estão corretas</span>
										</v-checkbox>
									</v-card-text>
								</v-card>
							</v-container>
						</v-card>
						<v-card-actions v-if="!carregaDados && filial.status == 'AGUARDANDO CONFIRMAÇÃO'">
							<v-flex md12 xs12 sm12 lg3>
								<v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="avancaPasso2">Continuar</v-btn>
							</v-flex>
						</v-card-actions>
					</v-stepper-content>
					<!-- FIM DO PASSO 1 -->

					<!-- PASSO 2 -->
					<v-stepper-content step="2">
						<v-card class="mb-1" flat>
							<v-container grid-list-md>
								<v-layout row wrap>
									<v-flex xs12 sm12 lg12>
										<p class="form-titulo">Concluir Solicitação</p>
									</v-flex>
									<v-flex xs12 sm12 md12 lg8>
										<iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
									</v-flex>
									<v-flex xs12 sm12 md12 lg4>
										<div v-if="this.$vuetify.breakpoint.lg">
											<v-list-tile @click="pdfSelecionado = 'https://ecommerce.primavida.com.br/contratos/CREDENCIAMENTO/tabela_de_valores_primavida.pdf'" avatar>
												<v-list-tile-action>
													<img src="../Content/images/pdf.png" width="30px">
												</v-list-tile-action>
												<v-list-tile-title>Tabela de Valores</v-list-tile-title>
											</v-list-tile>
										</div>
										<div v-else>
											<v-list-tile v-if="pdfSelecionado = 'https://ecommerce.primavida.com.br/contratos/CREDENCIAMENTO/tabela_de_valores_primavida.pdf'" @click="pdfSelecionado = pdfSelecionado" :href="pdfSelecionado" target='_blank' avatar>
												<v-list-tile-action>
													<img src="../Content/images/pdf.png" width="30px">
												</v-list-tile-action>
												<v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
											</v-list-tile>
										</div>
									</v-flex>
									<v-flex xs12 sm3 md12 lg12>
										<v-checkbox v-model="aceitaCredenciamento" color="#009B99">
											<span slot="label">Li e concordo com os valores estabelecidos na tabela</span>
										</v-checkbox>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card>
						<v-card-actions>
							<v-flex md12 xs12 sm12 lg3>
								<v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="finalizaConfirmacao">Confirmar</v-btn>
							</v-flex>
						</v-card-actions>
					</v-stepper-content>
					<!-- FIM DO PASSO 2 -->
				</v-stepper-items>
			</v-stepper>
			<v-dialog v-model="dialogoConfirmacao" max-width="450px" max-height="300px" persistent>
				<v-card style="border-radius: 12px;">
					<v-container grid-list-md>
						<v-layout row wrap justify-center>
							<v-card-title>
								<span class="total">PARABÉNS</span>
							</v-card-title>
							<v-container fill-height fluid pa-1 justify-center class="resumo">
								<p class="subtotal" style="text-align: center; text-size: 12px">Sua confirmação foi realizada!</p>
							</v-container>
						</v-layout>
						<v-card-actions>
							<v-container fill-height fluid pa-1 justify-center>
								<v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="recarregaPagina">Fechar</v-btn>
							</v-container>
						</v-card-actions>
					</v-container>
				</v-card>
			</v-dialog>
		</section>
		<loading :active.sync="isLoading" :can-cancel="true" color="#7593b4" :is-full-page="fullPage"></loading>
		<Snackbar ref=chamaSnackbar />
	</div>
</template>

<script>
	import Snackbar from '../components/snackbar.vue'
	import axios from 'axios'
	// Import component
	import Loading from 'vue-loading-overlay';
	// Import stylesheet
	import 'vue-loading-overlay/dist/vue-loading.css';
	import { baseApiUrl } from '@/global'
	export default {
		components: {Snackbar, Loading},
		data() {
			return {
				step: 0,
				logradouro: '',
				cidade: '',
				estado: '',
				bairro: '',
				pdfSelecionado: 'https://ecommerce.primavida.com.br/contratos/CREDENCIAMENTO/tabela_de_valores_primavida.pdf',
				status: 'CARREGANDO STATUS DO CADASTRO...',
				fullPage: true,
				isLoading: false,
				carregaDados: true,
				confirmaCadastro: false,
				aceitaCredenciamento: false,
				dialogoConfirmacao: false,
				filial: [],
				contatos: [],
				especialidades: [],
				funcionarios: [],
			}
		},

		mounted : function() {
			localStorage.clear()
			sessionStorage.clear()
			this.pegaParametrosUrl()
		},

		methods: {
			async pegaParametrosUrl() {
				var params = window.location.search.substring(1).split('?');
				if (params[0] != '') {
					//Criar objeto que vai conter os parametros
					var paramArray = {};
					//Passar por todos os parametros
					for (var i=0; i<params.length; i++) {
						//Dividir os parametros chave e valor
						var param = params[i].split('=');
						//Adicionar ao objeto criado antes
						paramArray[param[0]] = param[1];
					}
					if (paramArray['cl']) {
						await axios.post(`${baseApiUrl}Filials/getFilialAndFunc`, {"filialId": paramArray['cl']}).then(response => {
							if (response.data) {
								this.filial = response.data
								this.status = "STATUS DO CADASTRO: " + response.data.status
								this.retornoCEP(this.filial.logCep)
								this.contatos = response.data.contatos
								this.especialidades = response.data.especialidades.toString().replaceAll(',', ', ')
								this.funcionarios = response.data.funcionarios
								this.carregaDados = false
							}
						})
					}
				}
			},

			async retornoCEP(cep) {
				try {
					let response = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : cep}) 
					if (response.data != '') {
						this.logradouro = response.data.Logradouro
						this.cidade = response.data.Municipio
						this.estado = response.data.Uf
						this.bairro = response.data.Bairro
					}
				} catch (error) {
					var vmcep = this;
					vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
				}
			},

			formatDateBrz(date) {
				if (!date) return null
				const [year, month, day] = date.split('-')
				return `${day}/${month}/${year}`
			},

			avancaPasso2() {
				if (!this.confirmaCadastro) {
					var vm = this;
					vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, confirme os dados!","ATENÇÃO")
				} else {
					this.step = 2
				}
			},

			async finalizaConfirmacao() {
				if (!this.aceitaCredenciamento) {
					var vm = this;
					vm.$refs.chamaSnackbar.snack("#F9A825","Para confirmar, é necessário concordar com os valores estabelecidos da tabela!","ATENÇÃO")
				} else {
					this.isLoading = true
					let ipConfirm
					let dateConfirm
					try {
						let response = await axios.get(`https://api.ipify.org/?format=json`)
						if (response.data != null) {
							ipConfirm = response.data.ip
						} else {
							ipConfirm = '127.0.0.0'
						}
					} catch (error) {
						ipConfirm = '127.0.0.1'
					}
					dateConfirm = new Date().toISOString()
					await axios.patch(`${baseApiUrl}Filials/${this.filial.id}`, {"status": 'EM ANÁLISE', "credencConfirm": dateConfirm, "credencIPConfirm": ipConfirm}).then(response => {
						if (response.data) {
							this.isLoading = false
							this.dialogoConfirmacao = true
						}
					})
				}
			},

			recarregaPagina() {
				window.location.reload()
			},
		}
	}
</script>

<style>
	.link {
		font-size: 1.3rem;
		color: #194383;
		text-align: center;
	}

	.titulo {
		font-size: 2rem;
		color: #797a7a;
		text-align: center;
	}

	.imagemBanner {
		background: url("../Content/images/bannerCredenciamento.png");
		background-repeat: no-repeat;
		position: relative;
		z-index: 1;
	}

	.pagina-titulo {
		background: #e2f1f2;
		font-size: 18px;
		line-height: 26px;
		color: #333;
		margin-bottom: 20px;
	}

	.pagina-titulo .centro {
		margin-left: 15px;
		padding: 40px 0 50px;
	}

	.pagina-titulo .rotulo-planos {
		color: #666;
		font-size: 22px;
		font-weight: 300;
		line-height: 40px;
		text-transform: uppercase;
	}

	.pagina-titulo .o-titulo {
		font-size: 30px;
		font-weight: 700;
		line-height: 50px;
		margin-bottom: 10px;
		color: #666;
	}

	.pagina-titulo .o-titulo span {
		color: #009b9b;
	}
</style>